// extracted by mini-css-extract-plugin
export default {"container":"AccountAggregator_container__jns32","main":"AccountAggregator_main__pUhrd","body":"AccountAggregator_body__3ImKJ"};